<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="card" style="background:#f1f1f1; padding-left:0;padding-right:0;">
        <h5 class="card-header text-primary">{{$t("message.please_change_your_password")}}</h5>
        <div class="card-body">
          <form class="form" v-on:submit.prevent>
            <div class="mb-3 mt-3">
              <label for="old_pswd" class="form-label">{{$t("message.old_password")}}:</label>
              <input type="text" 
                class="form-control" 
                id="old_pswd" 
                :placeholder='$t("message.old_password")' 
                v-model="formPass.old_password"
                :class="{ 'is-invalid': v$.formPass.old_password.$error }"
                name="old_pswd">
            </div>
            <div class="mb-3">
              <label for="pwd" class="form-label">{{$t("message.new_password")}}:</label>
              <input type="password" 
                    class="form-control" 
                    id="pwd" 
                    :placeholder='$t("message.new_password")' 
                    v-model="formPass.password"
                    :class="{ 'is-invalid': v$.formPass.password.$error }"
                    name="pswd">
            </div>
            <div class="mb-3">
              <label for="confirm_pwd" class="form-label">{{$t("message.confirm_password")}}:</label>
              <input type="password" 
                    class="form-control" 
                    id="confirm_pwd" 
                    :placeholder='$t("message.confirm_password")'
                    v-model="formPass.password_confirmation"
                    :class="{
                      'is-invalid': v$.formPass.password_confirmation.$error
                    }"
                    name="confirm_pswd">
            </div>
            <button type="submit" 
              class="btn btn-primary"
              @click="saveChangePassword">{{$t("message.change_password")}}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import useVuelidate from "@vuelidate/core";
  import { required, sameAs } from "@vuelidate/validators";
  import axios from "@/axios";
  export default {
    setup() {
      return {
        v$: useVuelidate()
      };
    },
    data() {
      return {
        formPass: {
          old_password: '',
          password: '',
          password_confirmation: ''
        }
      };
    },
    validations() {
      return {
        formPass: {
          old_password: { required, $autoDirty: true },
          password: { required, $autoDirty: true },
          password_confirmation: {
            required,
            sameAsPassword: sameAs(this.formPass.password),
            $autoDirty: true
          }
        }
      }
    },
    methods: {
      showLoader() {
        return this.$loading.show({
          // Optional parameters
          container: this.$refs.formContainer,
          color: "#01B201",
          canCancel: true,
          onCancel: this.onCancelLoader
        });
      },
      saveChangePassword(){
        this.v$.$validate(); // checks all inputs
        if (!this.v$.$error) {
          this.$swal
            .fire({
              title: this.$t("message.do_you_want_change_your_password"),
              showCancelButton: true,
              confirmButtonText: this.$t("message.yes"),
              cancelButtonText: this.$t("message.cancel")
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                  let loader = this.showLoader();
                  try {
                    const respone = await axios.post("changepwt", this.formPass, {
                      headers: {
                        Authorization: "Bearer " + this.$store.getters.getAuthToken
                      }
                    });
                    if (respone.status == 200) {
                      if (respone.data.success) {
                        this.$toast.open({
                            message: this.$t("message.your_password_has_been_change"),
                            type: "success",
                            duration: 5000,
                            dismissible: true,
                            position: "top-right"
                          });
                      }
                    }
                  } catch (error) {
                    this.$toast.open({
                      message: error.response.data.message,
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                      position: "top-right"
                    });
                  }
                  this.formPass = {
                    old_password: '',
                    password: '',
                    password_confirmation: ''
                  };
                  loader.hide();
              }
            });
        }
      }
    },
    created() {},
    mounted() {}
  }
</script>

<style scope></style>